import { render, staticRenderFns } from "./MandateCodes.vue?vue&type=template&id=6c1fe7f2&scoped=true&"
import script from "./MandateCodes.vue?vue&type=script&lang=js&"
export * from "./MandateCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1fe7f2",
  null
  
)

export default component.exports